import "core-js/modules/es6.array.fill";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { useState as n, useEffect as r, createElement as e, useRef as t, useCallback as i } from "react";

function a(t) {
  var i = t.speed,
      a = void 0 === i ? .5 : i,
      o = t.direction,
      c = void 0 === o ? "left" : o,
      l = t.pauseOnHover,
      d = t.children,
      f = function (n, r) {
    if (null == n) return {};
    var e,
        t,
        i = {},
        a = Object.keys(n);

    for (t = 0; t < a.length; t++) {
      r.indexOf(e = a[t]) >= 0 || (i[e] = n[e]);
    }

    return i;
  }(t, ["speed", "direction", "pauseOnHover", "children"]),
      v = n(1),
      s = v[0],
      m = v[1],
      y = u(),
      p = y[0],
      h = y[1],
      O = u(),
      b = O[0],
      q = O[1];

  return r(function () {
    h && q && m(Math.ceil(h / q));
  }, [h, q]), e("div", Object.assign({
    ref: p,
    "data-marqy": "",
    "data-direction": c,
    "data-pause-on-hover": l ? "" : null
  }, f), e("div", {
    "data-marqy-inner": ""
  }, new Array(2).fill(0).map(function (n, r) {
    return e("div", {
      key: r,
      "data-marqy-content": "",
      style: {
        animationDuration: (null != q ? q : 0) * s / (100 * a) + "s"
      }
    }, new Array(s).fill(0).map(function (n, t) {
      var i = 0 === r && 0 === t;
      return e("div", {
        key: t,
        ref: i ? b : null,
        "aria-hidden": !i || null,
        "data-marqy-item": ""
      }, d);
    }));
  })));
}

function u() {
  var e = n(0),
      a = e[0],
      u = e[1],
      o = n(null),
      c = o[0],
      l = o[1],
      d = t(null),
      f = i(function () {
    var n;
    return null == (n = d.current) ? void 0 : n.disconnect();
  }, []),
      v = i(function () {
    d.current = new ResizeObserver(function (n) {
      return u(n[0].contentRect.width);
    }), c && d.current.observe(c);
  }, [c]);
  return r(function () {
    return v(), function () {
      return f();
    };
  }, [f, v]), [l, a];
}

export { a as Marqy };